import React from 'react'
import Imgix from 'react-imgix'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import 'swiper/components/scrollbar/scrollbar.scss'
import 'swiper/components/pagination/pagination.scss'
import '../../styles/customSwiper.scss'
import { useResolutionService } from '../../hooks'

const SwiperSlideQuestsHighlights = () => {
  const { isMDScreen } = useResolutionService()
  return (
    <div>
      <Swiper
        slidesPerView={3}
        navigation
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          425: {
            slidesPerView: 1.1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.1,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 1.5,
            spaceBetween: 30,
          },
          1440: {
            slidesPerView: 2.5,
            spaceBetween: 40,
          },
          2560: {
            slidesPerView: 2.5,
            spaceBetween: 80,
          },
        }}
        className='overflow-xy custom-swiper custom-swiper-arrow'>
        <SwiperSlide>
          {' '}
          <div style={{ width: '100%' }}>
            <Imgix
              className='border-radius-10 mt-4 lazyload imgix-object-cover'
              imgixParams={{
                fit: 'crop',
                crop: 'edges',
                ar: isMDScreen ? '2:1' : '5:3',
              }}
              src={`${process.env.REACT_APP_IMG_SOURCE}/StaticHighlights1.png`}
              width={'100%'}
              alt='image'
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={{
                src: `${
                  process.env.REACT_APP_IMG_SOURCE
                }/StaticHighlights1.png?ar=${
                  isMDScreen ? '2:1' : '5:3'
                }&fit=crop&crop=edges&fill=blur&blur=300&px=16&auto=format`, // low quality image here
              }}
            />
            <h4 className='s10a pt-16px font-saffron-700'>
              More than a Retreat
            </h4>
            <p className='s6'>
              While retreats offer temporary escape, Abroad experiences are
              designed for lasting transformation. With structured preparation,
              integration, coaching, assessment, and lifelong community, our
              programs go beyond relief, delivering impact you can feel and
              measure.
            </p>{' '}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          {' '}
          <div style={{ width: '100%' }}>
            <Imgix
              className='border-radius-10 mt-4 lazyload imgix-object-cover'
              imgixParams={{
                fit: 'crop',
                crop: 'edges',
                ar: isMDScreen ? '2:1' : '5:3',
              }}
              src={`${process.env.REACT_APP_IMG_SOURCE}/StaticHighlights2.png`}
              width={'100%'}
              alt='image'
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={{
                src: `${
                  process.env.REACT_APP_IMG_SOURCE
                }/StaticHighlights2.png?ar=${
                  isMDScreen ? '2:1' : '5:3'
                }&fit=crop&crop=edges&fill=blur&blur=300&px=16&auto=format`, // low quality image here
              }}
            />
            <h4 className='s10a mt-3 font-saffron-700'>
              Wisdom-Based Leadership
            </h4>
            <p className='s6'>
              Abroad brings together luminary faculty, executive coaches, and
              wisdom keepers who embody both lived experience and timeless
              insight. They may not always be famous, but they’ve done the deep
              inner work and can guide others toward meaningful growth in life
              and leadership.
            </p>{' '}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          {' '}
          <div style={{ width: '100%' }}>
            <Imgix
              className='border-radius-10 mt-4 lazyload imgix-object-cover'
              imgixParams={{
                fit: 'crop',
                crop: 'edges',
                ar: isMDScreen ? '2:1' : '5:3',
              }}
              src={`${process.env.REACT_APP_IMG_SOURCE}/StaticHighlights3.png`}
              width={'100%'}
              alt='image'
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={{
                src: `${
                  process.env.REACT_APP_IMG_SOURCE
                }/StaticHighlights3.png?ar=${
                  isMDScreen ? '2:1' : '5:3'
                }&fit=crop&crop=edges&fill=blur&blur=300&px=16&auto=format`, // low quality image here
              }}
            />
            <h4 className='s10a mt-3 font-saffron-700'>
              High-Impact Community
            </h4>
            <p className='s6'>
              Abroad experiences bring together well-intentioned people and
              high-impact leaders to form lasting bonds. These aren’t networking
              events – they’re spaces to build genuine friendships, shared
              purpose, and lifelong collaboration.
            </p>{' '}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          {' '}
          <div style={{ width: '100%' }}>
            <Imgix
              className='border-radius-10 mt-4 lazyload imgix-object-cover'
              imgixParams={{
                fit: 'crop',
                crop: 'edges',
                ar: isMDScreen ? '2:1' : '5:3',
              }}
              src={`${process.env.REACT_APP_IMG_SOURCE}/StaticHighlights4.png`}
              width={'100%'}
              alt='image'
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={{
                src: `${
                  process.env.REACT_APP_IMG_SOURCE
                }/StaticHighlights4.png?ar=${
                  isMDScreen ? '2:1' : '5:3'
                }&fit=crop&crop=edges&fill=blur&blur=300&px=16&auto=format`, // low quality image here
              }}
            />
            <h4 className='s10a mt-3 font-saffron-700'>Curated Experiences</h4>
            <p className='s6'>
              Abroad is not a travel company… we’re more like a living art
              gallery. Each experience is carefully curated to offer something
              rare, beautiful, and transformative. Designed to reconnect you to
              yourself, others, and the world around you, Abroad experiences are
              crafted to ignite meaningful, measurable and lasting change.
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  )
}

export default SwiperSlideQuestsHighlights
